import { render, staticRenderFns } from "./AccountSettingNotification.vue?vue&type=template&id=dfdc6360&"
import script from "./AccountSettingNotification.vue?vue&type=script&lang=js&"
export * from "./AccountSettingNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfdc6360')) {
      api.createRecord('dfdc6360', component.options)
    } else {
      api.reload('dfdc6360', component.options)
    }
    module.hot.accept("./AccountSettingNotification.vue?vue&type=template&id=dfdc6360&", function () {
      api.rerender('dfdc6360', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/AccountSettingNotification.vue"
export default component.exports